export interface SimpleBanner {
  sample: unknown;
}
